import { COVER_CREDITS, coverSrc } from '@/lib/coverCredits'

interface CoverImageProps {
  /** Post slug — resolves the image path and any Unsplash attribution. */
  slug: string
  alt: string
}

/** Hero/cover image for a blog post, with Unsplash attribution when applicable. */
export function CoverImage({ slug, alt }: CoverImageProps) {
  const credit = COVER_CREDITS[slug]
  return (
    <figure className="not-prose">
      <img
        src={coverSrc(slug)}
        alt={alt}
        width={1600}
        height={1000}
        className="border-border aspect-[16/10] w-full rounded-lg border object-cover"
      />
      {credit && (
        <figcaption className="text-muted-foreground mt-2 text-xs">
          Photo by{' '}
          <a href={credit.photographerUrl} target="_blank" rel="noopener noreferrer" className="underline">
            {credit.photographer}
          </a>{' '}
          on{' '}
          <a href={credit.photoUrl} target="_blank" rel="noopener noreferrer" className="underline">
            Unsplash
          </a>
        </figcaption>
      )}
    </figure>
  )
}
